export const categories = [
  {
    slug: 'gaoxiao',
    name: '搞笑',
    icon: 'ri-emotion-laugh-line',
    description: '每日笑料不断，快乐从这里开始',
    color: 'accent',
  },
  {
    slug: 'shenghuo',
    name: '生活',
    icon: 'ri-home-heart-line',
    description: '记录美好生活，分享日常点滴',
    color: 'primary',
  },
  {
    slug: 'meishi',
    name: '美食',
    icon: 'ri-restaurant-line',
    description: '舌尖上的旅行，味蕾的狂欢',
    color: 'secondary',
  },
  {
    slug: 'shishang',
    name: '时尚',
    icon: 'ri-shirt-line',
    description: '潮流前沿，定义你的风格',
    color: 'accent',
  },
  {
    slug: 'lvxing',
    name: '旅行',
    icon: 'ri-earth-line',
    description: '世界那么大，带你去看看',
    color: 'primary',
  },
  {
    slug: 'keji',
    name: '科技',
    icon: 'ri-smartphone-line',
    description: '前沿科技，改变未来生活',
    color: 'secondary',
  },
  {
    slug: 'yinyue',
    name: '音乐',
    icon: 'ri-music-line',
    description: '旋律触动心灵，音符传递感动',
    color: 'accent',
  },
  {
    slug: 'tiyu',
    name: '体育',
    icon: 'ri-basketball-line',
    description: '激情赛场，热血时刻',
    color: 'primary',
  },
  {
    slug: 'dongwu',
    name: '萌宠',
    icon: 'ri-heart-pulse-line',
    description: '可爱萌宠，治愈你的每一天',
    color: 'secondary',
  },
  {
    slug: 'jiaoyu',
    name: '教育',
    icon: 'ri-book-open-line',
    description: '知识改变命运，学习成就未来',
    color: 'accent',
  },
  {
    slug: 'youxi',
    name: '游戏',
    icon: 'ri-gamepad-line',
    description: '游戏世界，乐趣无限',
    color: 'primary',
  },
  {
    slug: 'qiche',
    name: '汽车',
    icon: 'ri-car-line',
    description: '速度与激情，车迷的乐园',
    color: 'secondary',
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || null;
};